export enum OtpVerifyStatus {
  VERIFYING = 'verifying',
  FAILED = 'failed',
  VERIFIED = 'verified',
}
